import classesPopover from "../../../../../../components/Popover/popover.module.scss";
import classesProject from "../../../styles/popover.module.scss";
import { useState, useMemo } from "react";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { IUpdateProjectRequestParams } from "Dashboard/scenes/Projects/domain/IUpdateProjectRequestParams";
import { IMaskInput } from "react-imask";
import { projectService } from "Dashboard/scenes/Projects/services/project.service";
import { selectState, updateProject } from "../../Main/main.slice";
import { useSelector } from "react-redux";

const MealPriceSettingsPopover = () => {

  const dispatch = useAppDispatch();
  const { selectedIndex, projects } = useSelector(selectState);
  const selectedProject = projects[selectedIndex];

  const [project, setProject] = useState<IUpdateProjectRequestParams>({
    projectId: selectedProject.projectId,
    breakfastCost: selectedProject.breakfastCost,
    lunchCost: selectedProject.lunchCost,
    dinnerCost: selectedProject.dinnerCost,
    cashBreakfastRate: selectedProject.cashBreakfastRate,
    cashLunchRate: selectedProject.cashLunchRate,
    cashDinnerRate: selectedProject.cashDinnerRate,
    forcedField: "meal",
  });

  const delayedProjectUpdate = useMemo(
    () =>
      debounce(async (data: IUpdateProjectRequestParams) => {
        try {
          const project = await projectService.updateProject(data);
          dispatch(updateProject({ index: selectedIndex, project }));
        } catch (error) {
          console.log(error);
        }
      }, 1000),
    [dispatch, selectedIndex]
  );

  const updateFieldChanged = (name: string, value: string) => {
    let newValue: number | null;

    if (value !== "") {
      newValue = parseInt(value);
    } else {
      newValue = null;
    }

    let newProject = { ...project, [name]: newValue };
    delayedProjectUpdate(newProject);
    setProject(newProject);
  };

  return (
    <>
      {project && (
        <div className={`${classesProject.mealPriceSettingsPopover} ${classesPopover.basicPopover}`}>
          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>doručak</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.breakfastCost !== null ? `${project.breakfastCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("breakfastCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>
          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>ručak</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.lunchCost !== null ? `${project.lunchCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("lunchCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>
          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>večera</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.dinnerCost !== null ? `${project.dinnerCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("dinnerCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>keš doručak</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.cashBreakfastRate !== null ? `${project.cashBreakfastRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashBreakfastRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>keš ručak</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.cashLunchRate !== null ? `${project.cashLunchRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashLunchRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>


          <div className={classesPopover.row}>
            <div className={`${classesPopover.col} ${classesPopover.rowDir}`}>
              <label className={classesPopover.mr5}>keš večera</label>
              <IMaskInput
                className={classesPopover.itemBorder}
                value={project.cashDinnerRate !== null ? `${project.cashDinnerRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashDinnerRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

        </div>
      )}
    </>
  );
};

export default MealPriceSettingsPopover;
